<template>
    <Popup
        buttonText="popupBetBuilderTutorial_gotIt"
        title="popup_smp_tutorial_title"
        v-bind:contentStyle="popupStyle"
        class="SportsLobby_BetBuilder_Tutorial"
        v-on:callback="closePopup"
    >
        <template #content>
            <I18nT keypath="popup_smp_tutorial_introduction" tag="p" />
            <div class="popupModal-content-img">
                <picture>
                    <source v-bind:srcset="`${imageUrl.webp}`" type="image/webp">
                    <img
                        v-bind:src="`${imageUrl.origin}`"
                        alt=""
                        aria-hidden="true"
                    >
                </picture>
            </div>
        </template>
    </Popup>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import Popup from '@/components/common/Popup.vue';
    import { useBetBuilderTutorialPopup } from '@/libraries/composables/popup/useBetBuilderTutorialPopup';

    export default defineComponent({
        name: 'PopupAcceptAnyOdds',
        components: {
            Popup,
        },
        emits: ['close'],
        setup(_, { emit }) {
            const { imageUrl, popupStyle } = useBetBuilderTutorialPopup();

            const closePopup = () => {
                emit('close');
            };

            return {
                popupStyle,
                imageUrl,
                closePopup,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/popupModal";
</style>
